import { HttpClient } from '@angular/common/http';
import { TransferState } from '@angular/core';
import { UtilitiesService } from '@magneto/core';
import { TranslateServerLoader, TranslateBrowserLoader } from '@magneto/translate-loaders';
import { environment } from 'environments/environment';

export function faqCategoryTranslateLoaderFactory(
  transferState: TransferState,
  http: HttpClient,
  utilityService: UtilitiesService,
) {
  if (utilityService.isServer()) {
    return new TranslateServerLoader(transferState, http, [
      { prefix: 'assets/i18n/general/faq/faq-category', suffix: '.json' },
      { prefix: 'assets/i18n/general/faq/shared', suffix: '.json' },
      { prefix: 'hd-assets/i18n/molecules/search-bar', suffix: '.json' },
    ]);
  } else {
    return new TranslateBrowserLoader(transferState, http, [
      { prefix: 'assets/i18n/general/faq/faq-category', suffix: '.json?cb=' + environment.VERSION },
      { prefix: 'assets/i18n/general/faq/shared', suffix: '.json?cb=' + environment.VERSION },
      { prefix: 'hd-assets/i18n/molecules/search-bar', suffix: '.json?cb=' + environment.VERSION },
    ]);
  }
}
